import { render, staticRenderFns } from "./VPSFFOtpDeliveryComponent.vue?vue&type=template&id=51b3ddd9&scoped=true"
import script from "./VPSFFOtpDeliveryComponent.vue?vue&type=script&lang=js"
export * from "./VPSFFOtpDeliveryComponent.vue?vue&type=script&lang=js"
import style0 from "./VPSFFOtpDeliveryComponent.vue?vue&type=style&index=0&id=51b3ddd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b3ddd9",
  null
  
)

export default component.exports